"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderModal = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _PromoModal = require("@cian/ui-kit/modal/components/PromoModal");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _useSlider = require("./hooks/useSlider");
var _PageIndicator = require("./components/PageIndicator/PageIndicator");
var _Content = require("./components/Content");
var _SliderModal = _interopRequireDefault(require("./SliderModal.css"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
var _sliderModalContext = require("./utils/sliderModalContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SliderModal = props => {
  const {
    slides,
    onClose,
    onScrollNext,
    onArticleClick
  } = props;
  const {
    containerRef,
    currentSlide,
    showPrevSlide,
    showNextSlide
  } = (0, _useSlider.useSlider)({
    totalSlides: slides.length,
    onScrollNext
  });
  const deviceType = (0, _uiKit.useDeviceType)();
  const sliderModalContext = React.useMemo(() => ({
    onArticleClick
  }), [onArticleClick]);
  const isPhone = deviceType === 'phone';
  return /*#__PURE__*/React.createElement(_sliderModalContext.SliderModalContext.Provider, {
    value: sliderModalContext
  }, /*#__PURE__*/React.createElement(_PromoModal.PromoModalRoot, {
    open: true,
    onOpenChange: onClose
  }, /*#__PURE__*/React.createElement(_PromoModal.PromoModalContent, null, /*#__PURE__*/React.createElement(_PromoModal.PromoModalCloseButton, {
    theme: "fill_light",
    size: "XS",
    icon: /*#__PURE__*/React.createElement(_icons.IconActionClose16, {
      color: "current_color"
    }),
    title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
  }), /*#__PURE__*/React.createElement("div", {
    className: _SliderModal.default['slider']
  }, /*#__PURE__*/React.createElement("ul", {
    ref: containerRef,
    className: _SliderModal.default['container']
  }, slides.map((slide, index) => /*#__PURE__*/React.createElement(_Content.Content, (0, _extends2.default)({
    key: index
  }, slide))))), /*#__PURE__*/React.createElement(_PromoModal.PromoModalFooter, null, /*#__PURE__*/React.createElement("div", {
    className: _SliderModal.default['actions']
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    desktop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(currentSlide === 0 && _SliderModal.default['hidden'])
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    theme: "fill_secondary",
    onClick: showPrevSlide
  }, "\u041D\u0430\u0437\u0430\u0434"))), /*#__PURE__*/React.createElement(_PageIndicator.PageIndicator, {
    currentPage: currentSlide,
    totalPages: slides.length
  }), currentSlide < slides.length - 1 && /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    desktop: true
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    onClick: showNextSlide
  }, "\u0414\u0430\u043B\u0435\u0435")), currentSlide === slides.length - 1 && /*#__PURE__*/React.createElement(_uiKit.Button, {
    fullWidth: isPhone,
    onClick: onClose
  }, "\u0411\u0443\u0434\u0443 \u0437\u043D\u0430\u0442\u044C"))))));
};
exports.SliderModal = SliderModal;